import { render, staticRenderFns } from "./profile-upload.vue?vue&type=template&id=35efceda&scoped=true&"
import script from "./profile-upload.vue?vue&type=script&lang=js&"
export * from "./profile-upload.vue?vue&type=script&lang=js&"
import style0 from "./profile-upload.vue?vue&type=style&index=0&id=35efceda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35efceda",
  null
  
)

export default component.exports